import {Component, OnInit} from '@angular/core';
import {ProductListing} from 'src/app/raintree/interface/product-listing/product-listing';
import {FabricFilterService} from '../product-filter-sidebar/service/fabric-filter.service';
import {UntilDestroy} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
	selector: 'fb-product',
	templateUrl: './product.component.html',
	styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {

	public products: ProductListing[] = [];
	public productLength: number = 0;

	constructor(
		private fabricFilterService: FabricFilterService
	) {
	}

	public listingDataPassToFilter(evt: ProductListing[]): void {
		// debugger
		this.products = evt;
		this.productLength = this.products.length
	}

	public productLengthUpdate(length: number): void {
		// debugger
		this.productLength = length;
	}



	public ngOnInit(): void {
		this.fabricFilterService.filteredData.subscribe((data:ProductListing[])=>{
			this.productLength = data.length;
		});
	}
}
